import React, { useEffect, useState, useMemo } from 'react';
import styles from './AddDevice.module.css';
import { useNavigate } from "react-router-dom";
import QrScannerComponent from "./QrScannerComponent/QrScannerComponent";
import config from "../../../settings/config";
import useAuthToken from "../../../hooks/useAuthToken";
import useStateBackend from "../../../hooks/useBackendStatus";
import backArrow from "../../../img/backArrow.png";
import { useToast } from "../../../context/ToastContext";


const AddDevice = () => {
    const [isScanning, setIsScanning] = useState(false);
    const [tempData, setTempData] = useState("");
    const [manualInput, setManualInput] = useState("");
    const [manualInputCode, setManualInputCode] = useState("");
    const [isManualInput, setIsManualInput] = useState(false);
    const [isManualInputCode, setIsManualInputCode] = useState(false);
    const navigate = useNavigate();
    const { setToast } = useToast();
    const token = useAuthToken();
    useStateBackend();

    const showToast = (message, type, time) => {
        setToast({ message, type });
        setTimeout(() => setToast(null), time);
    };

    const handleScan = (data) => {
        console.log(data)
        if (data && data.text && !isScanning) {
            const cleanedText = data.text.replace(/^http:\/\//, "");
            if (cleanedText.length >= 9 && (tempData !== cleanedText)) {
                setTempData(cleanedText);
                setIsScanning(true);
                getRequest(cleanedText).finally(setIsScanning(false));
            } else {

            }
        }
    };

    async function getRequest(data) {
        console.log("Clean text: " + data)
        try {
            // Выполняем запрос с параметрами
            const response = await fetch(`${config.app.host}/api/v1/device/addNewDevice?serialNumberAndCode=${data}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            });

            // Проверяем Content-Type перед парсингом JSON
            const contentType = response.headers.get('content-type');
            let responseData;

            if (contentType && contentType.includes('application/json')) {
                responseData = await response.json();
                console.log(responseData);
            } else {
                // Если ответ не JSON, читаем как текст
                const text = await response.text();
                responseData = text ? { message: text } : { message: 'Пустой ответ от сервера' };
            }

            if (!response.ok) {
                const errorMessage = responseData?.message || 'Неизвестная ошибка';
                console.log(errorMessage);

                if (response.status === 400) {
                    showToast(errorMessage, "error", 3000);
                    navigate('/devices');
                    return;
                }

                showToast(errorMessage, "error", 3000);
                return;
            }

            // Успешный ответ
            navigate('/devices');
            showToast("Устройство успешно добавлено", "success", 3000);

        } catch (error) {
            console.error('Ошибка:', error);
            showToast('Ошибка подключения: ' + error.message, "error", 3000);
        }
    }

    const handleManualSubmit = () => {
        if (manualInput.length >= 9 && manualInputCode.length == 12) {
            handleScan({ text: manualInput + "-" + manualInputCode });
        } else {
            showToast("Введите номер длиной не менее 9 символов и код длиной 12 символов", "warn", 3000);
        }
    };

    const handleManualInputChange = (e) => {
        setManualInput(e.target.value);
        setIsManualInput(e.target.value.length >= 1); // Когда пользователь начинает вводить текст
    };

    const handleManualInputChangeCode = (e) => {
        setManualInputCode(e.target.value);
        setIsManualInputCode(e.target.value.length >= 1); // Когда пользователь начинает вводить текст
    };


    const handleError = (error) => {
        console.error("QR Scanner Error:", error);
    };

    const handleBack = () => {
        navigate(-1);
    }

    return (
        <div className={styles.container}>
            <div className={styles.section}>
                <h1 className={styles.titleText}>Добавление нового устройства</h1>

                {!isManualInput && (
                    <div>
                        <p><br />Отсканируйте qr-code</p>
                        <div className={styles.camContainer}>
                            <QrScannerComponent onScan={handleScan} onError={handleError} />
                        </div>
                    </div>
                )}
                <p><br />Введите номер устройства</p>
                <input
                    className={styles.formInput}
                    type="text"
                    placeholder="Введите номер и код устройства"
                    required
                    value={manualInput}
                    onChange={handleManualInputChange}
                />
                <br />
                <input
                    className={styles.formInput}
                    type="text"
                    placeholder="Введите код устройства"
                    required
                    value={manualInputCode}
                    onChange={handleManualInputChangeCode}
                />
            </div>
            <div className={styles.button}>
                <div className={styles.buttonsBg}>
                    <button
                        className={styles.buttonBack}
                        onClick={handleBack}
                    >
                        <img className={styles.backArrow} src={backArrow} alt="backArrow"></img>
                    </button>
                    <button
                        className={manualInput.length >= 9 && manualInputCode.length == 12
                            ? styles.buttonAdd : styles.buttonAddOff}
                        onClick={handleManualSubmit}
                    >
                        Добавить устройство
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AddDevice;